import { DropDownOption } from '@grays-npm/component-library';

export const universalSortOptions = [
  { value: 'ReserveHightoLow', label: 'Reserve High to Low' },
  { value: 'ReserveLowtoHigh', label: 'Reserve Low to High' },
  { value: 'ShortDescriptionAsc', label: 'Item A - Z' },
  { value: 'ShortDescriptionDesc', label: 'Item Z - A' },
  { value: 'SubStatusAsc', label: 'Sale Type A - Z' },
  { value: 'SubStatusDesc', label: 'Sale Type Z - A' },
] as DropDownOption[];

export const activeSortOptions = (
  [{ value: 'EndingSoonest', label: 'Ending Soonest' }] as DropDownOption[]
).concat(universalSortOptions);

export const pendingSortOptions = (
  [{ value: 'StartingSoonest', label: 'Starting Soonest' }] as DropDownOption[]
).concat(universalSortOptions);

export const soldSortOptions = (
  [{ value: 'RecentlySold', label: 'Recently Sold' }] as DropDownOption[]
).concat(universalSortOptions);

export const unsoldSortOptions = (
  [{ value: 'RecentlyClosed', label: 'Recently Closed' }] as DropDownOption[]
).concat(universalSortOptions);
